import { useEffect, useState } from 'react'

export const useIsTesting = () => {
  const [isTesting, setIsTesting] = useState(
    localStorage.getItem('isTesting') === 'ON' ? true : false,
  )

  useEffect(() => {
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key === 'isTesting') {
        setIsTesting(event.newValue === 'ON' ? true : false)
      }
    })
  }, [])

  return { isTesting }
}
